export default __webpack_public_path__ + "img/45bbddc4845a52fd8174b654a91aab42.png";